// extracted by mini-css-extract-plugin
module.exports = {"exclamationIcon":"PolicyDocumentError_exclamationIcon__DeUvP"};